import { render, staticRenderFns } from "./PriorityRulesFilter.vue?vue&type=template&id=0ccd9030&"
import script from "./PriorityRulesFilter.vue?vue&type=script&lang=ts&"
export * from "./PriorityRulesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports